<template>
  <div class="paper-share-page-wrapper" v-if="hasRight" :style="{ backgroundImage: bgUrl }" :class="{ mobile: isMobile }">
    <div class="header" :class="[{ 'list-head_pc': showList && !isMobile }, { 'list-head_mobile': showList && isMobile }, { advanced: showMore }]">
      <div class="title-logo" v-show="!(isMobile && showList)">
        <img class="logo" :src="logoUrl" />
      </div>
      <div class="search-wrapper">
        <el-input class="search-input" placeholder="请输入关键字" v-model="queryName">
          <template slot="append"><a @click="getArticleList">搜索文章</a></template>
        </el-input>
        <div class="more-btn" @click="showMore = !showMore">高级搜索&nbsp;<img v-show="!showMore" src="@imgs/paper/unfoldBtn.png" /><img v-show="showMore" src="@imgs/paper/foldBtn.png" /></div>
        <div class="advanced-search" v-show="showMore">
          <div class="advanced-search-item">
            <span class="title">报纸名称：&nbsp;</span>
            <el-select class="advanced-input" v-model="baozhiName" size="mini">
              <el-option v-for="(item, index) in paperList" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </div>
          <div class="advanced-search-item">
            <span class="title">报纸刊期：</span>&nbsp;
            <div class="date-selector">
              <el-date-picker class="advanced-input" size="mini" v-model="fromDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp"> </el-date-picker>&nbsp;
              <span class="title">至 &nbsp;</span>
              <el-date-picker class="advanced-input" size="mini" v-model="toDate" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="timestamp"> </el-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="article-list" :class="{ advanced: showMore }" v-show="showList">
      <list-frame v-if="!isMobile" class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="20">
        <template v-slot:listContent>
          <div class="paper-list-content">
            <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
              <el-table-column prop="title" label="文章名称" min-width="200"> </el-table-column>
              <el-table-column prop="baoZhiName" label="报纸名称" min-width="100"> </el-table-column>
              <el-table-column prop="epaperName" label="数字报名称" min-width="100"> </el-table-column>
              <el-table-column prop="periodical" label="报纸刊期" min-width="100"> </el-table-column>
              <el-table-column prop="edition" label="版次" min-width="50"> </el-table-column>
              <el-table-column label="操作" min-width="150">
                <template slot-scope="scope">
                  <div class="option-button" @click="goDetail(scope.row)">查看文章</div>
                  <div class="option-button" @click="goDetail(scope.row, 'epaper')">查看当期报纸</div>
                  <div class="option-button" @click="shareItem(scope.row)">分享</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </list-frame>
      <div v-else class="list">
        <div class="list-title">文章名称</div>
        <el-scrollbar ref="listContent" class="list-content">
          <div id="scrollDom">
            <div v-for="(item, index) in tableData" v-bind:key="index" @click="showDetail(item)" class="article-list-item">{{ item.title }}</div>
            <div v-if="totalCount < 1" class="article-list-item">暂无数据</div>
          </div>
        </el-scrollbar>
        <div class="page-counts">
          共 <span>{{ totalCount }}</span> 条记录
        </div>
        <div class="page-footer">
          <img class="footer-icon" src="@imgs/paper/go-first.png" :class="{ 'no-event': currentPageNo <= 1 }" @click="flipPage(1)" title="" />
          <img class="footer-icon" src="@imgs/paper/go-pre.png" :class="{ 'no-event': currentPageNo <= 1 }" @click="flipPage(currentPageNo - 1)" />
          <div class="text">{{ currentPageNo + '/' + totalPages }}</div>
          <img class="footer-icon fd-footer-icon" src="@imgs/paper/go-next.png" :class="{ 'no-event': currentPageNo >= totalPages }" @click="flipPage(currentPageNo + 1)" />
          <img class="footer-icon fd-footer-icon" src="@imgs/paper/go-last.png" :class="{ 'no-event': currentPageNo >= totalPages }" @click="flipPage(totalPages)" />
        </div>
      </div>
    </div>
    <share-dialog ref="shareDialog" :qrObj="qrObj" :title="'分享报纸'" :typeName="'paper'" :isInset="false"></share-dialog>
    <article-dialog ref="articleDialog" @handleClick="handleClick" :articleItem="articleItem"></article-dialog>
  </div>
  <div class="paper-share-page-wrapper" v-else-if="loaded">
    <h1>作者会员已到期，此网页暂时无法继续查看</h1>
  </div>
</template>
<script>
import wxSetting from '@components/common/wxSetting'
import api from '@api/paperManager'
import ListFrame from '@components/list/listFrame'
import moment from 'moment'
import ShareDialog from '@components/books/components/ShareDialog.vue'
import ArticleDialog from '../components/PaperArticleLib/components/ArticleDialog'
import vip from '@api/vip.js'

export default {
  name: 'PaperSharePage',
  mixins: [wxSetting],
  data() {
    return {
      title: '报纸文章库',
      logoUrl: require('@imgs/paper/logo@2x.png'),
      totalPaper: 0,
      bgUrl: '',
      queryName: '',
      baozhiName: '',
      paperList: [],
      tableData: [],
      totalCount: 0,
      totalPages: 0,
      currentPageNo: 1,
      fromDate: '',
      toDate: '',
      showList: false,
      showMore: false,
      articleItem: {},
      isPop: false,
      hasRight: false,
      loaded: false,
      qrObj: {
        value: '',
        iframeUrl: '',
        isShowPoster: 0,
        title: ''
      }
    }
  },
  components: {
    ListFrame,
    ShareDialog,
    ArticleDialog
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    userName() {
      return this.$route.query.user
    }
  },
  async created() {
    let param = {
      userName: this.$route.query.user
    }
    vip.getVipRightByUsername(param).then((res) => {
      if (res.data && res.data.data) {
        this.hasRight = res.data.data.articleLib == 1
      }
      this.loaded = true
    })
    this.init()
  },
  mounted() {
    let wxParams = {
      userName: this.userName,
      grouping: 1,
      currentUrl: window.location.href
    }
    api.wxGroupShareParams(wxParams).then((res) => {
      if (res.data && res.data.status === 0) {
        const data = res.data.data
        this.setWXConfig(data)
      }
    })
  },
  methods: {
    async init() {
      const param = {
        userName: this.userName,
        pageNo: 1,
        pageSize: 99
      }
      api.getPaperManagerList(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.paperList = res.data.data.content
          this.totalPaper = this.paperList.length
        } else {
          this.paperList = []
        }
      })
      api.getGroupShareSetting(this.userName, 1).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          const data = res.data.data
          this.title = data.title
          this.logoUrl = data.logo ? data.logo : require('@imgs/paper/logo@2x.png')
          this.showStyle = data.topicColor
          this.openMode = data.openMode
          let url = data.backgroud
          if (url) {
            if (url.length === 1 || url.length === 2) {
              url = require('@/assets/imgs/paper/bg' + url + '.png')
            }
            if (url.length > 1) {
              this.bgUrl = `url(${url})`
            }
          }
        }
        document.title = this.title
      })
    },
    getArticleList() {
      if (!this.showMore) {
        this.baozhiName = ''
        this.fromDate = ''
        this.toDate = ''
      }
      if (!this.baozhiName && !this.queryName && !this.fromDate && !this.toDate) {
        this.$message({
          message: '请输入检索条件'
        })
        return
      }
      const param = {
        pageNo: this.currentPageNo,
        pageSize: 20,
        baoZhiName: this.baozhiName,
        publishDateStart: this.fromDate || '',
        publishDateEnd: this.toDate || '',
        title: this.queryName,
        userName: this.userName
      }
      api.getPaperArticleList(param).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.showList = true
          let data = res.data.data
          this.tableData = data.content.map((item) => {
            return {
              ...item,
              periodical: item.publishDate ? moment(item.publishDate).format('YYYY-MM-DD') : ''
            }
          })
          this.totalCount = data.totalElements
          this.totalPages = data.totalPages
        }
      })
    },
    //翻页
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getArticleList()
    },
    shareItem(item) {
      this.$refs.shareDialog.dialogVisible = true
      let routeUrl = this.$router.resolve({ path: '/digitalArticle', query: { id: item.id } })
      this.qrObj.value = window.location.origin + routeUrl.href
      this.qrObj.iframeUrl = '<iframe src="' + this.qrObj.value + '" style="width:100%;height:99.5%"></iframe>'
      this.qrObj.title = item.title
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0 && options.columnIndex !== 1) {
        return 'text-align: center'
      }
    },
    showDetail(item) {
      this.$refs.articleDialog.dialogVisible = true
      this.articleItem = item
    },
    handleClick(val) {
      this.goDetail(this.articleItem, val)
    },
    goDetail(item, type) {
      let link
      if (type === 'epaper') {
        let routeUrl = this.$router.resolve({
          path: '/paperContent',
          query: { id: item.epaperId }
        })
        link = window.location.origin + routeUrl.href
      } else {
        let routeUrl = this.$router.resolve({ path: '/digitalArticle', query: { id: item.id } })
        link = window.location.origin + routeUrl.href
      }
      let a = document.createElement('a')
      a.href = link
      a.target = '_blank'
      a.click()
    }
  }
}
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0px !important;
  border-radius: 10px !important;
  background-color: #fed79c !important;
  z-index: 0 !important;
}
.paper-share-page-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background-image: url('../assets/imgs/paper/share_bg_red.png');
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  overflow-y: scroll;
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    .title-logo {
      img.logo {
        width: 240px;
      }
      margin-bottom: 30px;
    }
    .search-wrapper {
      .search-input {
        width: 500px;
        .el-input-group__append {
          background-color: #df5813;
        }
      }
      .more-btn {
        font-size: 14px;
        color: #ffffff;
        margin-top: 30px;
        cursor: pointer;
        img {
          width: 11px;
        }
      }
      .advanced-search {
        font-size: 12px;
        color: #ffffff;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        .advanced-search-item {
          margin-right: 10px;
          display: flex;
          align-items: center;
        }
        .el-select {
          .el-input {
            height: 20px;
          }
        }
      }
    }
    &.list-head_pc {
      flex-direction: row;
      margin-top: 100px;
      align-items: flex-start;
      .title-logo {
        margin-right: 30px;
        margin-bottom: 0;
        justify-content: center;
        img.logo {
          width: 144px;
          vertical-align: middle;
        }
      }
      .search-wrapper {
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        min-width: 620px;
        .more-btn {
          position: absolute;
          margin-top: 0;
          left: 520px;
          top: 10px;
          width: 100px;
        }
        .advanced-search {
          margin-left: -100px;
        }
      }
    }
  }
  .article-list {
    margin: 20px 80px;
    //height: calc(100vh - 200px);
    background-color: #fff;
    position: relative;
    .common-list-wrapper {
      background-color: #fff;
      width: 100%;
      padding: 10px 50px;
      .el-pagination1 {
        width: 100%;
      }
      .el-table {
        .option-button {
          color: #df5813;
          cursor: pointer;
          display: inline-block;
          margin-right: 20px;
        }
      }
    }
  }
  &.mobile {
    background-size: auto 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow-y: hidden;
    .header {
      width: 100%;
      padding: 0 15px;
      justify-content: flex-start;
      margin-top: calc(50vh - 180px);
      .advanced-search {
        flex-direction: column;
        width: 100%;
        .advanced-search-item {
          flex-wrap: wrap;
          margin: 0 auto 30px;
          width: 95%;
          justify-content: center;
          &:last-child {
            align-items: flex-start;
            margin-bottom: 0;
          }
          .advanced-input {
            width: 200px;
          }
          span.title {
            display: block;
            line-height: 28px;
            text-align: left;
          }
        }
      }
      &.list-head_mobile {
        padding-top: 30px;
        justify-content: flex-start;
        height: 120px;
        margin-top: 0;
        &.advanced {
          height: 270px;
        }
        .search-wrapper {
          min-width: auto;
        }
        .more-btn {
          position: relative;
          width: 100%;
          text-align: center;
          margin-top: 20px;
        }
        .advanced-search {
          margin-top: 20px;
        }
      }
    }
    .article-list {
      height: calc(100vh - 160px);
      width: 100%;
      &.advanced {
        height: calc(100vh - 300px);
      }
      .list {
        height: 100%;
      }
      .list-title {
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        height: 40px;
        background-color: #f5f5f5;
        line-height: 40px;
        padding: 0 15px;
      }
      .list-content {
        padding: 0 15px 40px;
        max-height: 100%;
        overflow-y: scroll;
        .article-list-item {
          font-size: 14px;
          text-align: left;
          height: 40px;
          line-height: 40px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          border-bottom: #f5f5f5 solid 1px;
          &:last-child {
            margin-bottom: 70px;
          }
        }
      }
      .page-counts {
        position: fixed;
        bottom: 40px;
        background-color: #fff;
        text-align: center;
        width: 100%;
        span {
          color: #df5813;
        }
      }
      .page-footer {
        position: fixed;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        text-align: center;
        background-color: #eeeeee;
        .footer-icon {
          width: 26px;
          height: 26px;
          vertical-align: middle;
          margin-right: 20px;
          &.no-event {
            pointer-events: none;
          }
        }
        .text {
          color: #515151;
          display: block;
          font-size: 12px;
          background-color: #ffffff;
          width: 70px;
          height: 26px;
          line-height: 26px;
        }
      }
    }
    .search-wrapper {
      .search-input {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.paper-share-page-wrapper {
  .search-input {
    .el-input-group__append {
      background-color: #df5813;
      border-color: #df5813;
      color: #ffffff;
      cursor: pointer;
    }
  }
  &.mobile {
  }
}
</style>
